module.exports = __webpack_public_path__ + "img/icon-yinlian.e73c7dcb.png";